import * as React from "react";
import { SVGProps, memo } from "react";

const HeadingM = (props: SVGProps<SVGSVGElement> & { slot?: string }) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M6 8H8V6H11.252L8.68 18H6V20H14V18H11.748L14.32 6H18V8H20V4H6V8Z" fill="currentColor" /></svg>;

const Memo = memo(HeadingM);
export default Memo;